<template>
    {{ isShortPopUp }}
    <LongPopUpNotification
        v-if="isLongPopUp"
        :showModal="showModal"
        :notification="notification"
        @closeModal="onCloseModal"
    ></LongPopUpNotification>
    <ShortPopUpNotification
        v-else-if="isShortPopUp"
        :showModal="showModal"
        :notification="notification"
        @closeModal="onCloseModal"
    ></ShortPopUpNotification>
</template>

<script>
import LongPopUpNotification from "@/Components/UI/Notification/PopUpNotification/LongPopUpNotification.vue";
import ShortPopUpNotification from "@/Components/UI/Notification/PopUpNotification/ShortPopUpNotification.vue";

export default {
    components: {
        LongPopUpNotification,
        ShortPopUpNotification,
    },

    props: {
        showModal: Boolean,
        notification: Object,
    },

    emits: ["closeModal"],

    computed: {
        isLongPopUp() {
            return this.notification?.type == 1;
        },
        isShortPopUp() {
            return this.notification?.type == 2;
        },
    },

    methods: {
        async onCloseModal(event) {
            console.log({event})
            this.$emit("closeModal");
            this.handleReadPopUp(event.isUsed);
        },
        async handleReadPopUp(isUsed) {
            try {
                await axios.put(this.route("dashboard.readPopUp"), {
                    userId: this.$page.props.auth.user.id,
                    popupId: this.notification?.id,
                    used: isUsed,
                });
            } catch (error) {}
        },
    },
};
</script>
